(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var contents = drawer.querySelector('[data-cart-contents]');
  var status = drawer.querySelector('[data-cart-status]');
  var sectionId = drawer.dataset.sectionId;
  // Depuis le passage des tiroirs en section group, `section.id` n'est plus
  // `cart-drawer` mais un identifiant dynamique (`sections--1234__cart-drawer`).
  // On demande les deux : la Section Rendering API renvoie `null` pour celui
  // qu'elle ne sait pas rendre, et l'autre prend le relais. Le repli statique
  // est rendu avec les réglages par défaut du schéma — donc sans les
  // traductions attachées au groupe : il ne sert qu'en second.
  var sectionIds = sectionId === 'cart-drawer' ? [sectionId] : [sectionId, 'cart-drawer'];
  var busy = false;
  var previousFocus;
  var previousOverflow;

  // Garder le brouillon et la langue, y compris après disparition du paramètre
  // de preview de la barre d'adresse. Aucun identifiant de boutique en dur.
  function contextURL(path) {
    var url = new URL(path, window.location.origin);
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    var theme = window.Shopify && window.Shopify.theme;
    if (!preview && theme && theme.role !== 'main') preview = theme.id;
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  // Shopify redirige les mutations /cart/*.js si preview_theme_id est présent
  // dans leur URL. L'ajout a alors déjà réussi, mais la redirection ne renvoie
  // plus le JSON attendu. Le cookie de preview suffit pour ces endpoints ; le
  // paramètre reste réservé aux pages et aux requêtes de rendu de sections.
  function cartEndpoint(path) {
    return new URL(path, window.location.origin);
  }

  var cartURL = contextURL(drawer.dataset.cartUrl);
  drawer.querySelector('[data-cart-page-link]').href = cartURL.href;

  function open(returnFocus) {
    if (drawer.hasAttribute('data-open')) return;
    previousFocus = returnFocus || document.activeElement;
    previousOverflow = document.body.style.overflow;
    drawer.inert = false;
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close].cart-drawer__close').focus();
  }

  function close() {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.body.style.overflow = previousOverflow || '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }

  function setBusy(value) {
    busy = value;
    contents.setAttribute('aria-busy', String(value));
    contents.inert = value;
  }

  function showError(message, stale) {
    status.textContent = message;
    status.hidden = false;
    // Ne jamais présenter un ancien panier vide comme le résultat d'un ajout.
    if (stale) contents.hidden = true;
  }

  async function request(url, options) {
    var response = await fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options));
    var data = await response.json();
    if (!response.ok) {
      var error = new Error('Cart request failed');
      // Un message Shopify est du texte, jamais du HTML à injecter.
      if (response.status === 422) error.customerMessage = data.description;
      throw error;
    }
    return data;
  }

  function pickSection(sections) {
    if (!sections) return null;
    for (var i = 0; i < sectionIds.length; i++) {
      if (sections[sectionIds[i]]) return sections[sectionIds[i]];
    }
    return null;
  }

  function render(html) {
    if (!html) throw new Error('Missing cart section');
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-contents]');
    if (!fresh || !/^\d+$/.test(fresh.dataset.itemCount || '')) throw new Error('Invalid cart section');
    var count = Number(fresh.dataset.itemCount);
    contents.innerHTML = fresh.innerHTML;
    contents.dataset.itemCount = String(count);
    contents.hidden = false;
    status.hidden = true;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    drawer.querySelector('.cart-drawer__count').textContent = '(' + count + ')';
  }

  async function refresh(data) {
    // Le rendu groupé vient de la même mutation que l'ajout / changement.
    var bundled = data && pickSection(data.sections);
    if (bundled) {
      try { render(bundled); return; } catch (_) { /* Retenter la lecture uniquement. */ }
    }
    var url = contextURL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', sectionIds.join(','));
    var sections = await request(url.href, { headers: { Accept: 'application/json' } });
    render(pickSection(sections));
  }

  function sectionContext() {
    var url = contextURL(window.location.href);
    url.searchParams.delete('sections');
    url.searchParams.delete('section_id');
    return url.pathname + url.search;
  }

  drawer.addEventListener('click', async function (event) {
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    var button = event.target.closest('[data-cart-qty]');
    if (!button || busy) return;
    var item = button.closest('[data-cart-key]');
    if (!item) return;
    var key = item.dataset.cartKey;
    var buttonIndex = Array.from(item.querySelectorAll('[data-cart-qty]')).indexOf(button);
    setBusy(true);
    try {
      var data = await request(cartEndpoint(drawer.dataset.changeUrl).href, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(button.dataset.cartQty), sections: sectionIds, sections_url: sectionContext() })
      });
      await refresh(data);
      if (document.querySelector('[data-cart-main]')) window.location.assign(cartURL.href);
    } catch (error) {
      showError(error.customerMessage || 'Le panier ne peut pas être actualisé. Consultez votre panier pour vérifier son contenu.', true);
    } finally {
      setBusy(false);
      if (drawer.hasAttribute('data-open')) {
        var updatedItem = Array.from(contents.querySelectorAll('[data-cart-key]')).find(function (el) { return el.dataset.cartKey === key; });
        var nextFocus = !contents.hidden && updatedItem && updatedItem.querySelectorAll('[data-cart-qty]')[buttonIndex];
        (nextFocus || drawer.querySelector('[data-cart-page-link]')).focus();
      }
    }
  });

  document.addEventListener('click', async function (event) {
    var opener = event.target.closest('[data-cart-open]');
    if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    // Sur /cart le contenu est déjà visible ; éviter deux vues divergentes.
    if (document.querySelector('[data-cart-main]')) return;
    event.preventDefault();
    open();
    if (busy) return;
    // Shopify a déjà rendu le tiroir avec le panier courant au chargement de la
    // page, et chaque mutation renvoie son propre HTML à jour. Ce rafraîchissement
    // ne sert qu'à rattraper un panier modifié dans un autre onglet : il reste
    // silencieux, sans voile d'attente sur un contenu déjà juste, et un échec
    // laisse l'affichage en place au lieu de présenter un tiroir vide.
    busy = true;
    try { await refresh(); }
    catch (_) { /* Le contenu rendu par Shopify reste affiché. */ }
    finally { busy = false; }
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer.hasAttribute('data-open')) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) {
      return !el.closest('[inert]') && el.getClientRects().length > 0;
    });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (focusable.indexOf(document.activeElement) === -1) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.action || new URL(form.action).pathname !== new URL(drawer.dataset.addUrl, window.location.origin).pathname.replace(/\.js$/, '')) return;
    event.preventDefault();
    if (busy) return;
    var submit = event.submitter || form.querySelector('[type="submit"]');
    var body = new FormData(form);
    body.set('sections', sectionIds.join(','));
    body.set('sections_url', sectionContext());
    setBusy(true);
    if (submit) submit.disabled = true;
    try {
      var data = await request(cartEndpoint(drawer.dataset.addUrl).href, { method: 'POST', headers: { Accept: 'application/json' }, body: body });
      try { await refresh(data); }
      catch (_) { showError('Votre article a été ajouté. Consultez votre panier pour retrouver votre sélection.', true); }
    } catch (error) {
      // Une panne réseau peut survenir APRÈS l'ajout : ne jamais refaire le POST.
      showError(error.customerMessage || 'Impossible de confirmer cet ajout. Vérifiez votre panier avant de réessayer.', true);
    } finally {
      setBusy(false);
      if (submit) submit.disabled = false;
      open(submit);
    }
  });
})();
